// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { OptionGroup } from "../OptionGroup"
import { useI18n } from "@/i18n"
import type { AnswerDraft } from "../types"

interface Props {
  value: AnswerDraft
  onChange: (patch: AnswerDraft) => void
  /** Tap-to-advance (owner reference video): one tap answers AND continues. */
  onSelected?: () => void
}

/** Step 5 (wire) — dietary style (hard rule for every plan). */
export function Step5Dietary({ value, onChange, onSelected }: Props) {
  const { t } = useI18n()
  const dietaryStyle = (value.dietaryStyle as string | undefined) ?? null

  return (
    <OptionGroup
      legend={t("onboarding.step5.title")}
      columns={2}
      value={dietaryStyle}
      onChange={next => {
        onChange({ dietaryStyle: next })
        onSelected?.()
      }}
      options={[
        { value: "omnivore", label: t("onboarding.step5.omnivore") },
        { value: "pescatarian", label: t("onboarding.step5.pescatarian") },
        { value: "vegetarian", label: t("onboarding.step5.vegetarian") },
        { value: "vegan", label: t("onboarding.step5.vegan") },
      ]}
    />
  )
}
